export interface IStokBarang {
    id: number;
    namaBarang: string;
    infoBarang: {
        nama: string;
        deskripsi?: string;
        url: string;
    };
    kategori: string;
    harga: number;
    jumlahStok: number;
    SKU: string;
    url: string;
}

export interface IKategori {
    id: number;
    nama: string;
}

export interface IInvoice {
    id: string;
    nomorInvoice: string;
    saldo: number;
    namaToko: string;
    alamatToko: string;
    email: string;
    noTelp: string;
    tanggalTransaksi: string;
    barang: {
        id: string;
        namaBarang: string;
        qty: number;
        harga: number;
    }[];
}

export interface LoginBody {
    email: string;
    password: string;
}

export interface RegistrasiForm {
    nama: string;
    username: string;
    email: string;
    no_telp: string;
    password: string;
    passwordUlang: string;
    referral: string;
    namaToko: string;
    alamat: string;
    provinsi?: {
        id: number;
        nama: string;
    };
    kota?: {
        id: number;
        nama: string;
        provinsiId: number;
        provinsiNama: string;
    };
}

export interface AuthState {
    isAuthenticated: boolean;
    isLoading: boolean;
    isRegistered: boolean;
    checkToken: (token: string) => void;
    login: (values: LoginBody) => void;
    logout: () => void;
    ukmIdUser: number[] | undefined;
    register: (values: RegistrasiForm) => void;
    handleRegistered: () => void;
    handleAuthenticated: (value: boolean) => void;
    setRegistered: React.Dispatch<React.SetStateAction<boolean>>;
    handleSetToken: (token: any) => Promise<void>;
    loginCount: number;
    resetLoginCount: () => void;
}

export interface CheckToken {
    code: number;
    message: string;
    data: string;
}

export interface LogoutResponse {
    code: number;
    message: string;
}

export interface LoginResponse {
    code: number;
    message: string;
    data: {
        token: string;
        user: UserResponse["data"];
    };
}

export interface RegistrasiResponse {
    code: number;
    message: string;
    data: {
        nama: string;
        username: string;
        email: string;
        alamat: string;
        no_telp: string;
        role: string;
        status: number;
        gambar: string | null;
        updated_at: string;
        created_at: string;
        id: number;
        token: string;
    };
}

export interface ErrorsFieldResponse {
    field: string;
    message: string;
}

export interface ErrorResponse {
    code: number;
    message: string;
    data: {
        errors: {
            field: string;
            message: string;
        };
    };
}

export type DefaultResponse = {
    code: number;
    message: string;
};

export type ItemContent = {
    id: number;
    nomer: number;
    nama: string;
    deskripsi: string | null;
    harga: number;
    sku: string;
    jumlah_stok: number | null;
    kategori: number;
    created_at: string | null;
    updated_at: string | null;
    deleted_at: string | null;
    kategoriwa: null | {
        id: number;
        nama: string;
        created_at: string | null;
        updated_at: string | null;
        deleted_at: string | null;
    };
};

export type ItemResponse = ItemContent[];

export type UserResponse = {
    code: number;
    data: {
        userId: number;
        namaLengkap: string;
        username: string;
        role: {
            id: string;
            nama: string;
        };
        isActive: number;
        aksesTransaksi: number;
        aksesStok: number;
        aksesLaporan: number;
        aksesRekapPenjualan: number;
        aksesMember: number;
        aksesParkir: number;
        aksesFoodcourt: number;
        aksesCowork: number;
        email: string;
        gambar: string | null;
        noTelp: string | null;
        ukmId: number[];
        referral: string | null;
        akses: {
            transaksi: number[];
            stok: number[];
            laporan: number[];
            keuangan: number[];
            rekapPenjualan: number[];
        };
        countProUkm: number;
    };
};

export type ParamsGetItem = {
    ukmId: number | undefined;
    search: string;
    kategori: string;
    size: number;
    isShow: number;
    page: number;
    column?: "nama" | "kategori" | "harga" | "stok" | "sku" | "kadaluarsa";
    sortby?: "asc" | "desc" | null;
};

export type GetItemResponse = {
    code: number;
    message: string;
    data: {
        ukmId: number | undefined;
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetItemResponse[];
        totalItem: number;
    };
};

export type ItemSatuan = {
    id: number;
    namaBarang: string;
    deskripsiBarang: string;
    sku: string;
    harga: number;
};

export type DetailBundling = {
    id: number;
    bundlingId: number;
    namaBarang: string;
    nama: string;
    deskripsiBarang: string;
    sku: string;
    harga: number;
    stok: number;
    jumlahYangDiambil: number;
    totalDiambil: number;
    faktur: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
    newFaktur?: IFaktur[];
};

export type ContentGetItemResponse = {
    id: number;
    nomer: number;
    namaBarang: string;
    deskripsi: string;
    sku: string;
    kategori: {
        id: number;
        nama: string;
    };
    gambar: string;
    harga: number;
    isActiveStok: boolean;
    favorite: number;
    stok: number;
    isBundling: number;
    itemSatuan: ItemSatuan[] | null;
    detailBundling: DetailBundling[] | [];
    isShow: number | string;
    hpp: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
    expAt: string;
    hargaMultiple: { id: number; harga: string; keterangan: string }[];
    keteranganItem: string | null;
    hargaSatuan: string;
};

export type JenisItem = {
    itemId: number;
    namaItem: string;
    skuItem: string;
    jumlahItem: number;
    hargaSatuan: number;
    hargaTotal: number;
};

export type InputPembayaranBody = {
    ukmId: number;
    jenisItem: JenisItem[];
    userInput: string;
    totalHarga: number;
    diskon: number;
    totalPembayaran: number;
    uangYangDibayar: number;
    kembalian: number;
};

export type InputPembayaranResponse = {
    code: number;
    message: string;
    data: {
        transaksiKe: string;
        nomorInvoice: string;
        jenisItem: JenisItem[];
        totalPembayaran: number;
        diskon: number;
        totalHarga: number;
        encrypt: string;
    };
};
export type ParamsGetKategori = {
    ukmId: number | undefined;
    search: string;
    size: number;
    page: number;
};

export type ParamsGetLanggananMember = {
    ukmId: number | undefined;
};

export type LanggananMemberData = {
    id: number;
    ukm?: { id: number; nama: string };
    nama: string | null;
    nominal: string | number | null;
    totalHari: string | null;
};

export type GetLanggananMemberResponse = {
    code: number;
    message: string;
    data: {
        content: LanggananMemberData[];
    };
};

export type GetKategoriResponse = {
    code: number;
    message: string;
    data: {
        ukmId: number | undefined;
        totalElements: number;
        page: number;
        lastPage: number;
        content: ContentGetKategoriResponse[];
    };
};

export type ContentGetKategoriResponse = {
    id: number;
    nama: string;
};

export type AddItemBody = {
    id: number;
    ukmId: number | undefined;
    namaBarang: string;
    deskripsiBarang: string;
    sku: string;
    gambar: File | null | string;
    kategoriBaru: string;
    kategoriId: IOptions;
    hargaBeli: number;
    harga: number;
    isActiveStok: boolean;
    jumlahStok: number | null;
    isKategoriBaru: boolean;
    favorite: boolean;
    isHPP: boolean;
    hpp: number;
    isShow?: boolean;
    multipleHarga: {
        persentase: number | string | null;
        harga: number | string;
        keterangan: string | null;
    }[];
};

export type AddItemResponse = {
    code: number;
    message: string;
    data: AddItemBody;
};

export type ParamsGetLaporanTotal = {
    ukmId: number | undefined;
    tanggalAwal: string;
    tanggalAkhir: string;
    coworkOnly?: number;
};

export type GetLaporanTotalResponse = {
    code: number;
    message: string;
    data: {
        totalPendapatan: number;
        totalTransaksi: number;
        jumlahStokTerjual: number;
    };
};

export type ParamsGetProdukTerjual = {
    search: string;
    size: number;
    page: number;
    ukmId: number | undefined;
    tanggalAwal: string;
    tanggalAkhir: string;
};

export type ContentGetProdukTerjual = {
    id: number;
    namaItem: string;
    skuItem: string;
    jumlahItem: string;
    totalHarga: string;
};

export type GetProdukTerjualResponse = {
    code: number;
    message: string;
    data: {
        ukmId: string;
        totalElements: number;
        page: number;
        lastPage: boolean;
        content: ContentGetProdukTerjual[];
    };
};

export type ParamsGetListMember = {
    size: number;
    page: number;
    search: string;
};

export type ContentGetListMemberItem = {
    id: number;
    ukm: {
        id: number;
        nama: string;
    };
    namaMember: string;
    perusahaan: string;
    noPolisi: string;
    jenislanggananId: {
        id: number;
        nama: string;
        nominal: number;
        totalHari: string;
    };
    startLangganan: string;
    endLangganan: string;
    isActive: 1 | 0;
};

export type GetListMemberResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetListMemberItem[];
    };
};

export type ParamsGetJenisLangganan = {
    size: number;
    page: number;
};

export type AddMemberBody = {
    namaMember: string;
    noPolisi: string;
    perusahaan: string;
    jenislanggananId: number;
    endLangganan: Date | null;
    metodePembayaran: {
        id: number;
        ukmId: { id: number; nama: string };
        namaMetode: string;
        noTujuan: string;
        namaPemegang: string;
        gambar: string | null;
        charge?: {
            mode: string | null;
            charge: number | null;
        };
    };
};

export type EditMemberBody = {
    namaMember: string;
    perusahaan: string;
    noPolisi: string;
    jenislanggananId: number;
    endLangganan: Date | null;
};

export type ExtendMemberBody = {
    namaMember: string;
    noPolisi: string;
    jenislanggananId: number;
    endLangganan: string;
    metodePembayaran: {
        id: number;
        ukmId: { id: number; nama: string };
        namaMetode: string;
        noTujuan: string;
        namaPemegang: string;
        gambar: string | null;
        charge?: {
            mode: string | null;
            charge: number | null;
        };
    };
};

export type AddKategoriBody = {
    ukmId: number;
    namaKategori: string;
};

export type AddKategoriResponse = {
    code: number;
    message: string;
};

export type EditKategoriBody = {
    namaKategori: string;
};

export type ModalStokField = {
    id: number;
    namaBarang: string;
    deskripsiBarang: string;
    kategoriId: IOptions;
    harga: number;
    sku: string;
    jumlahStok: number;
    isActiveStok: boolean;
    itemSatuan: ItemSatuan[] | null;
    isBundling: number;
    detailBundling: DetailBundling[] | [];
    favorite: boolean;
    isShow?: boolean;
    hargaMultiple: { id: number; harga: number; keterangan: string }[];
};

export type ProductsBundling = {
    itemId: number;
    jumlahItem: number;
};

export type AddProductBundling = {
    ukmId: number;
    namaBundling: string;
    deskripsiBundling?: string;
    kategoriBundling: string;
    sku: string;
    gambar: File | null;
    item: ProductsBundling[];
    hargaBundling: number;
    isActiveStok: boolean;
    jumlahStok: number;
};

export type SelectedProductBundling = {
    id: number;
    nama: string;
    harga: number;
    stok: number;
};

export type BundlingValues = {
    id: number | undefined;
    item: ProductsBundling[];
    namaBundling: string;
    deskripsiBundling: string;
    kategoriBundling: string | number;
    sku: string;
    hargaBundling: string;
    isActiveStok: boolean;
    jumlahStok: number;
    isKategoriBaru: boolean;
    kategoriBaru: string;
    gambar: File | null;
    favorite: boolean;
    isShow?: boolean;
    multipleHarga: {
        harga: number | string | undefined;
        keterangan: string | null;
    }[];
};

export type AddBundlingResponse = {
    code: number;
    message: string;
    data: {
        ukmId: number;
        namaBundling: string;
        deskripsiBundling: string;
        sku: string;
        kategoriBundling: string;
        gambar: string | null;
        hargaBundling: number;
        isActiveStok: 0 | 1; // 0 = false, 1 = true
        jumlahStok: number;
    };
};

export type ParamsGetListInvoice = {
    ukmId: number | undefined;
    search: string;
    size: number;
    page: number;
    tanggalAwal: string;
    tanggalAkhir: string;
    sales: string;
    kasir: string;
    metodeId: string;
    voidInvoice: string;
    openBill?: number;
};

export type ContentGetListInvoice = {
    id: number;
    encrypt: string;
    tanggal: string;
    transaksiKe: number;
    isReverted: number;
    nomorInvoice: string;
    hargaPenjualan: number;
    uangYangDibayar: number;
    kembalian: number;
    diskon: number | null;
    pajak: number | null;
    pajakPersen: number | null;
    charge: number | null;
    tipeCharge: number | null;
    // serviceCustom: number;
    // serviceCustomPersen: number;
    kasir: string;
    sales: string | null;
    metode: string | null;
    metodeArr: {
        namaMetode: string | null;
        charge: {
            mode: string | null;
            charge: string | null;
        };
        noTujuan: string | null;
        namaPemegang: string | null;
        gambar: string | null;
    };
    keterangan: string | null;
    faktur: {
        idFaktur: number;
        jumlah: number;
    };
    isWebstore: number | null;
    pelangganWebstore?: {
        namaPelanggan: string;
        nomorPelanggan: string;
        provinsi: string;
        kota: string;
        kecamatan: string;
        kelurahan: string;
        alamatPelanggan: string;
        rekeningPelanggan: string | null;
    } | null;
    statusWebstore: {
        id: number;
        status: string;
        pesan?: string;
        tanggal: string;
    }[];
    // daftarItem: {
    //     id: number;
    //     nomer: number;
    //     namaBarang: string;
    //     deskripsi: string;
    //     sku: string;
    //     kategori: {
    //         id: number;
    //         nama: string;
    //     }[];
    //     subKategori: {
    //         id: number;
    //         nama: string;
    //     }[];
    //     harga: number;
    //     isActiveStok: number;
    //     isShow: number;
    //     favorite: number;
    //     terjual: number;
    //     stok: number;
    //     isBundling: number;
    //     detailBundling: DetailBundling[];
    //     itemSatuan: null;
    //     hargaMultiple: { id: number; harga: number; keterangan: string }[];
    //     jumlahItem: number;
    //     hargaSatuan: string;
    //     hargaId: number | null;
    //     hargaTotal: number;
    //     keteranganItem: string | null;
    // }[];
    daftarItem: {
        id: number;
        namaBarang: string;
        namaKategori: string;
        sku: string;
        harga: number;
        url: string;
        qty: number;
        jumlahStok: number | undefined;
        detailBundling: DetailBundling[] | [];
        hpp: {
            id: number;
            faktur: string;
            hargaBeli: number;
            jumlah: number;
        }[];
        multipleHarga: {
            id: number;
            harga: number;
            keterangan: string | null;
        }[];
        hargaSatuan: string;
    }[];
    isLunas: number;
    totalPiutang: number;
    sisapiutang: number;
    isPiutang: number;
    jatuhTempo: string | null;
    pelangganId: string | number | null;
    pelangganNama: string | null;
    statusOpenBill: number;
    isOpenBill: number;
    pembayaranPiutangTerakhir: string | null;
    member?: string | null;
    noPolisi?: string | null;
};

export type GetListInvoiceResponse = {
    code: number;
    message: string;
    data: {
        ukmId: string;
        totalElements: number;
        page: number;
        lastPage: boolean;
        content: ContentGetListInvoice[];
        totalHarga: string;
        totalDiterima: string;
    };
};

export type ParamsGrafikPenjualan = {
    ukmId: number | undefined;
    tanggalAwal: string;
    tanggalAkhir: string;
    coworkOnly?: number;
};

export type GetGrafikPenjualanResponse = {
    code: number;
    message: string;
    data: {
        labels: string[];
        data: {
            totalPendapatan: number[];
            totalTransaksi: number[];
            jumlahProdukTerjual: number[];
        };
    };
};

export type ParamsGetDetailInvoice = {
    id?: number;
    grupProduk?: number;
};

export type DaftarItemListInvoice = {
    nomer: number;
    idItem: number;
    namaItem: string;
    namaKategori: string;
    skuItem: string;
    jumlahItem: number;
    hargaSatuan: number;
    hargaTotal: number;
    faktur: {
        idFaktur: number;
        jumlah: number;
    }[];
    keteranganItem: string | null;
    detailBundlingItem: DetailBundling[] | [];
};

export type DaftarKategoriListInvoice = {
    kategori: string;
    items: {
        keteranganItem: string | null;
        detailBundling: DetailBundling[] | [];
        detailBundlingItem: DetailBundling[] | [];
        nomer: number;
        idItem: number;
        namaItem: string;
        skuItem: string;
        jumlahItem: number;
        hargaSatuan: number;
        hargaTotal: number;
        faktur: {
            idFaktur: number;
            jumlah: number;
        }[];
    }[];
};

export type ParamsGetKategoriListInvoice = {
    grupProduk: 0 | 1;
};

export type GetDetailInvoiceResponse = {
    code: number;
    message: string;
    data: {
        tanggalTransaksi: string;
        nomorInvoice: string;
        daftarItem: DaftarItemListInvoice[];
        daftarKategori: DaftarKategoriListInvoice[];
        totalPembayaran: number;
        diskon: number;
        pajak: number;
        pajakPersen: number;
        serviceCustom: number;
        serviceCustomPersen: number;
        totalHarga: number;
        uangYangDibayar: number;
        kembalian: number;
        transaksiKe: string;
        kasir: string;
        sales: string;
        metode: string | null;
        metodeArr: {
            namaMetode: string | null;
            charge: {
                mode: string | null;
                charge: number | null;
            };
            noTujuan: string | null;
            namaPemegang: string | null;
            gambar: string | null;
        };
        keterangan: string | null;
        encrypt: string | null;
        charge: number | null;
        tipeCharge: string | null;
        isWebstore: number;
        pelangganWebstore?: {
            namaPelanggan: string;
            nomorPelanggan: string;
            provinsi: string;
            kota: string;
            kecamatan: string;
            kelurahan: string;
            alamatPelanggan: string;
            pemilikRekening: string | null;
            rekeningPelanggan: string | null;
        };
        member: string | null;
        noPolisi: string | null;
        endLangganan: string | null;
        isOpenBill: number;
        statusOpenBill: number;
        id: number;
        customHarga: number | null;
        isPiutang: number;
        totalPiutang: number;
        sisapiutang: number;
        jatuhTempo: string | null;
        pelangganId: number | null;
        pelangganNama: string | null;
        riwayatPembayaran: {
            id: number;
            keterangan: string;
            metode: string;
            nominal: number;
            tanggal: string;
        }[];
    };
};

export type GetPenyewaResponse = {
    code: number;
    message: string;
    data: PenyewaData[];
};

export type PenyewaData = {
    awalSewa: string;
    akhirSewa: string;
    harga: number;
    kapasitas: number;
    namaPerusahaan: string;
    penyewa: string;
    tanggalTransaksi: string;
    keterangan: string;
};

export type GetPenyewaHistoryResponse = {
    code: number;
    message: string;
    data: PenyewaHistoryData;
};

export type PenyewaHistoryData = {
    namaPerusahaan: string;
    npwpPerusahaan: string;
    nomorTelepon: string;
    alamat: string;
    namaPic: string;
    nomorTeleponPic: string;
    alamatPic: string;
    npwpPic: string;
    noKtpPic: string;
    sewaList: {
        awalSewa: string;
        akhirSewa: string;
        harga: number;
        kapasitas: number;
        namaRuangan: string;
        tanggalTransaksi: string;
    }[];
};

export type GetPenyewaKhususResponse = {
    code: number;
    message: string;
    data: PenyewaDataKhusus[];
};

export type PenyewaDataKhusus = {
    awalSewa: string;
    akhirSewa: string;
    harga: number;
    kapasitas: number;
    penyewa: string;
    namaPerusahaan: string;
    tanggalTransaksi: string;
    keterangan: string;
};

export type GetPenyewaSaatIniResponse = {
    code: number;
    message: string;
    data: PenyewaSaatIniData;
};

export type PenyewaSaatIniData = {
    hargaSewaBulananMember: number;
    hargaSewaBulananNonMember: number;
    hargaSewaMember: number;
    hargaSewaNonMember: number;
    namaPenyewa: string;
    nominalTagihan: number;
    penyewaId: number;
    periode: string;
    ruanganId: number;
    tanggalBerakhir: string;
    tanggalMulai: string;
    tipeHargaTerakhir: string;
    tanggal: string;
    jamMulai: string;
    jamBerakhir: string;
};


export type IncrementSKUResponse = {
    code: number;
    message: string;
    data: {
        urutanke: string;
    };
};

export type ParamsGetIncrementSKU = {
    ukmId: number | undefined;
};

export type ErrorFieldResponse = {
    message: string;
    errors: {
        [key: string]: string[];
    };
};

export type ContentUkm = {
    id: number;
    namaToko: string;
    gambarToko: string | null;
    gambarTokoBW: string | null;
    alamatToko: string;
    noTelp: string;
    warna: string;
    deskripsi: string | null;
    besarUsaha: string;
    jenisUsaha: string;
    omset: number;
    pajak: number | null;
    serviceCustom: number | null;
    isPro: number;
    lewatTempoPro: number;
    isActive: number | null;
    pembayaranBerikutnya: string | null;
    statusPembayaran: "ACTIVE" | "PAID" | "EXPIRED" | "-" | null;
    statusToko: 0 | 1 | 2 | 3 | 4 | 99;
    expiredTime: string;
    orderId: string;
    bank: string;
    layanan: {
        id: number;
        deskripsi: string;
        periode: string;
        harga: number;
    };
    limitItem: number | null;
    isTrial: number | null;
    trialTempo: string | null;
    trialFlag10: 0 | 1;
    kota: string | null;
    provinsi: string | null;
    isWebstore: number | null;
    tipeService: string;
    webCetakStruk: 0 | 1;
    webUkuranStruk: string;
    webKirimStruk: 0 | 1;
    webBarangTerjualTutupBuku: 0 | 1;
    apkCetakStruk: 0 | 1;
    apkUkuranStruk: string;
    apkPrintDapur: 0 | 1;
    apkKirimStruk: 0 | 1;
    apkBarangTerjualTutupBuku: 0 | 1;
    biayaParkir: number | null;
};

export type ParamsGetUkm = {
    search: string;
    size: number;
    page: number;
};

export type GetUkmResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: number;
        content: ContentUkm[];
    };
};

export type ParamsGetUkmIsDueExpired = {
    search: string;
    size: number;
    page: number;
    isDueExpired: number;
};

export type UserValues = {
    namaLengkap: string;
    username: string;
    email: string;
    gambar: File | string | null;
    noTelp: string | null;
};

export type EditUserResponse = {
    code: number;
    message: string;
    data: UserValues;
};

export type PasswordValues = {
    passwordLama: string;
    passwordBaru: string;
    passwordBaruUlang: string;
};

export type ChangePasswordResponse = {
    code: number;
    message: string;
};

export type ModalUkmField = {
    id?: number;
    namaToko: string;
    noTelp: string;
    alamatToko: string;
    warna: string;
    gambarToko?: File | string | null;
    deskripsi: string | null;
    besarUsaha: string;
    jenisUsaha: string;
    omset: string;
    provinsi?: {
        id: number;
        nama: string;
    };
    kota?: {
        id: number;
        nama: string;
        provinsiId: number;
        provinsiNama: string;
    };
    biayaParkir: string;
};

export type DownloadKatalogBody = {
    ukmId: number | undefined;
    kategori: string;
    tipe: string;
};

export type EditUkmResponse = {
    code: number;
    message: string;
};

export type GetInfiniteItemResponse = {
    pages: GetItemResponse["data"][];
    pageParams: (number | undefined)[];
};

export type SelectedProductMutasi = {
    id: number;
    nama: string;
    sku: string;
    harga: number;
    stok: number;
    hpp: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
};

export type ModalBundlingField = {
    id: number | undefined;
    item: ProductsBundling[];
    namaBundling: string;
    deskripsiBundling: string;
    kategoriBundling: string | number;
    sku: string;
    hargaBundling: string;
    isActiveStok: boolean;
    jumlahStok: number;
    favorite: boolean;
    isShow: boolean;
    hargaMultiple: { id: number; harga: number; keterangan: string }[];
};

export type DetailMutasi = {
    itemId: number;
    jumlahMasuk: number | null;
    jumlahKeluar: number | null;
    // hargaBeli: number;
    keterangan: string;
};

export type AddMutasiBody = {
    ukmId: number | undefined;
    detail: DetailMutasi[];
};

export type AddMutasiResponse = {
    code: number;
    message: string;
};

export type NestedDetail = {
    isMasuk: string;
    itemId: number;
    jumlahStok: string;
    // hargaBeli: number;
    keterangan: string;
    faktur?: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    };
    stokRepack: string | null;
    itemRepack: IOptions | null;
    hargaBeliRepack: number | null;
};

export type MutasiValues = {
    ukmId: number | undefined;
    detail: NestedDetail[];
};

export type ParamsGetMutasiStok = {
    ukmId: number | undefined;
    search: string;
    size: number;
    page: number;
    tanggalAwal: string;
    tanggalAkhir: string;
};

export type ContentGetMutasiStok = {
    nomor: number;
    ukm: {
        id: number;
        nama: string;
    };
    itemId: number;
    namaBarang: string;
    sku: string;
    stokAwal: number;
    hargaBeli: number;
    hargaBarang: number;
    masuk: number;
    keluar: number;
    jual: number;
    stokAkhir: number;
    keteranganMasuk: Keterangan[];
    keteranganKeluar: Keterangan[];
};

export type GetMutasiStokResponse = {
    code: number;
    message: string;
    data: {
        ukmId: string;
        totalElements: number;
        page: number;
        lastPage: boolean;
        content: ContentGetMutasiStok[];
    };
};

export type BuatTokoForm = {
    namaToko: string;
    noTelpToko: string;
    alamatToko: string;
    warna: string;
    deskripsiToko: string;
    jenisUsaha: string;
    besarUsaha: string;
    omzetPerTahun: string;
    logoToko: string | null;
};

export type BuatTokoResponse = {
    code: number;
    message: string;
    data: {
        nama: string;
        alamat: string;
        deskripsi: string | null;
        no_telp: string;
        warna: string;
        jenis_usaha: string;
        besar_usaha: string;
        omset: string;
        status: number;
        gambar: string | null;
        updated_at: string;
        created_at: string;
        id: number;
    };
};

export type NoWaAdminResponse = {
    code: number;
    message: string;
    data: {
        nama: string;
        nomor: string;
    };
};

export type ParamsPostUsersByUkm = {
    ukmId: number | undefined;
    size: number;
    page: number;
    search: string;
};

export type UsersByUkmContent = {
    userId: number;
    namaLengkap: string;
    username: string;
    aksesTransaksi: number;
    aksesStok: number;
    aksesLaporan: number;
    aksesMember: number;
    email: string;
    gambar: string | null;
    noTelp: string;
    ukmId: string[];
};

export type PostUsersByUkmResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: boolean;
        content: UsersByUkmContent[];
    };
};

export type IOptions = {
    id: string | number;
    nama: string;
};

export type LupaPasswordResponse = {
    code: number;
    message: string;
};

export type MetodeBayarData = {
    id: number;
    ukmId: { id: number; nama: string; isWebstore: number };
    namaMetode: string;
    charge?: {
        mode: string | null;
        charge: number | null;
    };
    noTujuan: string;
    namaPemegang: string;
    gambar: string | null;
    isShowWebstore: number;
    isBayarParkir: number;
};

export type GetMetodePembayaranResponse = {
    code: number;
    message: string;
    data: MetodeBayarData[];
};

export type GetFindMetodePembayaranResponse = {
    code: number;
    message: string;
    data: {
        id: number;
        ukmId: number;
        namaMetode: string;
        noTujuan: string;
        namaPemegang: string;
        gambar: string | null;
        charge: {
            mode: string;
            charge: number;
        };
    };
};

export type FindCustomStrukResponse = {
    code: number;
    message: string;
    data: {
        html: string | null;
    };
};

export type DataLayanan = {
    id: number;
    nama: string;
    deskripsiLayanan: string;
    harga: number;
    isHide: number;
    initialValue: 0 | 1;
};

export type GetLayananResponse = {
    code: number;
    message: string;
    data: DataLayanan[];
};

export type DaftarItemListStruk = {
    nomer: number;
    idItem: number;
    namaItem: string;
    jenisKendaraan: string;
    skuItem: string;
    jumlahItem: number;
    hargaSatuan: number;
    hargaTotal: number;
};

export type GetDetailStrukResponse = {
    code: number;
    message: string;
    data: {
        tanggalTransaksi: string;
        nomorInvoice: string;
        daftarItem: DaftarItemListStruk[];
        totalPembayaran: number;
        diskon: number;
        pajak: number;
        pajakPersen: number;
        serviceCustom: number;
        serviceCustomPersen: number;
        totalHarga: number;
        uangYangDibayar: number;
        kembalian: number;
        kasir: string;
        sales: string;
        metode: string | null;
        namaUkm: string;
        alamatUkm: string;
        noTelp: string;
        gambarToko: string | null;
        keterangan: string;
    };
};

export type SelectedFakturMutasi = {
    id: number;
    kodeFaktur: string;
    hargaBeli: number;
    jumlahStok: number;
};

export type ParamsGetFakturPembelian = {
    ukmId?: number | string;
    search: string;
    size: number;
    page: number;
};

export type ContentGetFakturPembelianResponse = {
    id: number;
    nomer: number;
    ukm: {
        id: number;
        nama: string;
    };
    stok: {
        id: number;
        nama: string;
        sku: string;
        harga: number;
        jumlah: number;
    };
    faktur: string;
    keterangan: string | null;
    hargaBeli: number;
    jumlah: number;
    terjual: number;
};

export type GetFakturPembelianResponse = {
    code: number;
    message: string;
    data: {
        ukmId?: number[];
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetFakturPembelianResponse[];
    };
};

export type ParamsGetPengeluaran = {
    ukmId?: number | string;
    search: string;
    size: number;
    page: number;
    tanggalAwal?: string;
    tanggalAkhir?: string;
};

export type ContentGetPengeluaranResponse = {
    id: number;
    tanggal: string;
    nama: string;
    kode: string;
    penerima: string | null;
    totalNominal: string;
};

export type GetPengeluaranResponse = {
    code: number;
    message: string;
    data: {
        ukmId?: number[];
        totalElements: number;
        page: number;
        content: ContentGetPengeluaranResponse[];
    };
};

export type PengeluaranValues = {
    ukm?: string;
    tanggal: Date | null;
    keterangan: string;
    totalNominal: string | number;
    isKodeManual: boolean;
    kode: string;
};

export type ParamsGetLaporanLabaRugi = {
    ukmId?: number | string;
    tglawal: string;
    tglakhir: string;
};

export type GetLaporanLabaRugiResponse = {
    code: number;
    message: string;
    data: {
        content: {
            Revenue: {
                totalPendapatan: number;
                namaUkm: string;
            }[];
            "Total dari Revenue": number;
            "Cost of Sales": {
                totalPembelian: number;
                namaUkm: string;
            }[];
            "Total dari Cost of Sales": number;
            "Gross Profit": number;
            "Operational Expense": {
                totalBiaya: string;
                kodeBiaya: string;
                tanggalBiaya: string;
                namaBiaya: string;
                namaUkm: string;
            }[];
            "Total dari Operational Expense": number;
            "Profit (Loss)": number;
        };
    };
};

export interface ICart {
    id: number;
    namaBarang: string;
    namaKategori: string;
    sku?: string | undefined;
    qty: number;
    harga: number;
    url: string;
    jumlahStok?: number | undefined;
    detailBundling: DetailBundling[];
    hpp: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
    faktur: IFaktur[];
    multipleHarga: {
        id: number;
        harga: number;
        keterangan: string | null;
    }[];
    keteranganItem: string | null;
    hargaSatuan: string;
}

export interface IFaktur {
    fakturId: number;
    kodeFaktur: string;
    jumlahItem: number;
}

export type IDetailFaktur = {
    detail: {
        fakturId: number;
        kodeFaktur: string;
        jumlahStok: string;
    }[];
};

export type GetProvinsiResponse = {
    code: number;
    message: string;
    data: {
        content: {
            id: number;
            nama: string;
        }[];
    };
};

export type GetKotaResponse = {
    code: number;
    message: string;
    data: {
        content: {
            id: number;
            nama: string;
            provinsiId: number;
            provinsiNama: string;
        }[];
    };
};

export type GetTimeResponse = {
    abbreviation: string;
    client_ip: string;
    datetime: string;
    day_of_week: number;
    day_of_year: number;
    dst: boolean;
    dst_from: string | null;
    dst_offset: number;
    dst_until: string | null;
    raw_offset: number;
    timezone: string;
    unixtime: number;
    utc_datetime: string;
    utc_offset: string;
    week_number: number;
};

export type GetTimeAltResponse = {
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;
    seconds: number;
    milliSeconds: number;
    dateTime: string;
    date: string;
    time: string;
    timeZone: string;
    dayOfWeek: string;
    dstActive: boolean;
};

export interface Keterangan {
    jumlah: number;
    keterangan: string;
    tanggal: string;
    invoice: string;
    user: string | null;
}

export enum TipeStruk {
    Mobile = "MOBILE",
    PC = "PC",
    Mobile80 = "Mobile80",
    MobileDapur = "MobileDapur",
    Mobile80Dapur = "Mobile80Dapur",
}

export type PaymentRouteParams = {
    orderId: string;
    layananId: string;
    ukmId: string;
    type: string;
};

export type DataBanks = {
    method: string;
    payments: string[];
};

export type GetListBanksResponse = {
    code: number;
    message: string;
    data: {
        method: string;
        code: string;
        payments: string[];
        info: {
            nama: string;
            rekening: string;
            gambar: string;
        } | null;
    }[];
};

export type AddPaymentVAResponse = {
    code: number;
    message: string;
    data: {
        response_code: string;
        response_message: string;
        transaction_id: string;
        external_id: string;
        order_id: string;
        currency: string;
        transaction_status: string;
        payment_method: string;
        payment_channel: string;
        callback_url: string;
        payment_details: {
            payment_system: string;
            billing_name: string;
            va_number: string;
            amount: number;
            total_fee_amount: number;
            total_feenore_amount: number;
            total_promo_amount: number;
            total_amount: number;
            is_multi_use: boolean;
            layanan_amount: number;
            is_customer_paying_fee: boolean;
            expired_time: string;
            transaction_description: string;
        };
        customer_details: {
            email: string;
            full_name: string;
        };
        item_details: {
            item_id: string;
            name: string;
            amount: number;
            qty: number;
            description: string | null;
        }[];
    };
};

export type GetInquiryVAResponse = {
    code: number;
    message: string;
    data: {
        response_code: string;
        transaction_id: string;
        external_id: string;
        order_id: string;
        currency: string;
        transaction_status: string;
        transaction_time: string;
        payment_method: string;
        payment_channel: string;
        callback_url: string;
        customer_details: {
            email: string;
            full_name: string;
        };
        item_details: {
            item_id: string;
            name: string;
            amount: number;
            qty: number;
            description: string | null;
        }[];
        payment_history: [];
        payment_details: {
            payment_system: string;
            billing_name: string;
            va_number: string;
            amount: number;
            total_fee_amount: number;
            total_promo_amount: number;
            total_amount: number;
            total_paid_amount: number;
            is_multi_use: false;
            is_customer_paying_fee: false;
            expired_time: string;
            transaction_description: string;
        };
    };
};
export type GetStatusPembayaranResponse = {
    code: number;
    message: string;
    data: {
        transaction_id: string;
        transaction_status: string;
        status: number;
    };
};

export type CancelPembayaranVAResponse = {
    code: number;
    message: string;
    data: {
        transaction_id: string;
        external_id: string;
        order_id: string;
        payment_method: string;
        payment_channel: string;
        transaction_status: string;
        response_code: string;
        pembayaranId: number;
    };
};
export type ParamsKesimpulan = {
    ukmId: number | undefined;
    tanggal: string;
    grupProduk: number;
    isShift: number;
    shiftId?: number;
};

export type GetKesimpulanResponse = {
    code: number;
    message: string;
    data: {
        totalTransaksi: number;
        totalItemTerjual: number;
        totalServiceCustom: number;
        totalPajak: number;
        totalGross: number;
        totalDiskon: number;
        totalVoid: number;
        totalItemVoid: number;
        totalNet: number;
        totalPengeluaran: number;
        totalKendaraanParkir: number;
        totalMemberBaru: number;
        items: {
            nama: string | null;
            sku: string | null;
            jumlah: string;
        }[];
        metodePembayarans: {
            nama: string | null;
            total: string;
        }[];
        biaya: {
            kodeBiaya: string | null;
            namaBiaya: string | null;
            tanggalBiaya: string;
            totalBiaya: string;
        }[];
    };
};

export type PelangganParams = {
    ukmId: number | undefined;
    size: number;
    page: number;
};

export type PelangganContent = {
    id: number;
    ukm: {
        id: number;
        nama: string;
    };
    nama: string;
    noTelp: string;
    alamat: string | null;
    totalPiutang: number;
    piutangTerbayar: number;
};

export type PelangganResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: PelangganContent[];
    };
};

export type PiutangParams = {
    ukmId: number | undefined;
    search: string;
    size: number;
    page: number;
    piutang?: number;
    urutan?: number;
};

export type RiwayatPiutangParams = {
    ukmId: number | undefined;
    transaksiId: number;
};

export type RiwayatPiutang = {
    id: number;
    tanggal: string;
    nominal: string;
    dibayar: string;
    kembalian: number;
    keterangan: string | null;
    sisaPiutang: number;
    metode: {
        id: number | null;
        nama: string | null;
    };
    metodeArr: {
        id: number | null;
        nama: string | null;
        charge: {
            charge: number | null;
            mode: string | null;
        };
        gambar: string | null;
        namaMetode: string | null;
        namaPemegang: string | null;
        noTujuan: string | null;
    };
};

export type RiwayatPiutangResponse = {
    code: number;
    message: string;
    data: RiwayatPiutang[];
};

export enum PrintMode {
    A4 = "A4",
    LABEL109 = "Label",
    LABEL50X20 = "50mm x 20mm",
    LABEL33X15 = "33mm x 15mm",
}
export type ProsesParkirResponse = {
    code: number;
    message: string;
    data?: {
        id: number;
        ukm: {
            id: number;
            nama: string;
        };
        namaMember: string;
        noPolisi: string;
        jenislanggananId: {
            id: number;
            nama: string;
            nominal: number;
        };
        startLangganan: string;
        endLangganan: string;
        isActive: number;
    };
};

export type ParamsGetShiftNow = {
    ukmId: number | undefined;
    tipe: string;
};

export type GetShiftNowResponse = {
    code: number;
    message: string;
    data: {
        id: number;
        kasir: {
            id: number;
            nama: string;
        };
        kantungParkir: {
            id: number;
            nama: string;
        };
        mulaiShift: string;
        pengeluaran: number;
        pendapatan: number;
        kasAwal: number;
        penerimaanSistem: number;
        kasAkhir: number;
        selisih: number;
        catatan: string;
    };
};

export type ParamsGetListShift = {
    ukmId: number | undefined;
    size: number;
    page: number;
    tglAwal: string;
    tglAkhir: string;
};

export type ContentGetListShiftItem = {
    tanggal: string;
    listShift: {
        id: number;
        kasir: string;
        mulaiShift: string;
        akhirShift: string;
    }[];
};

export type GetListShiftResponse = {
    code: number;
    message: string;
    data: {
        ukmId: number;
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetListShiftItem[];
    };
};

export type ParamsGetListTransactionShift = {
    ukmId: number | undefined;
    shiftId: number;
};

export type ContentGetListTransactionShift = {
    id: number;
    nominal: number;
    keterangan: string;
    tanggal: string;
};

export type GetListTransactionShiftResponse = {
    code: number;
    message: string;
    data: {
        ukmId: number;
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetListTransactionShift[];
        infoShift: {
            id: number;
            kasir: {
                id: number;
                nama: string;
            };
            mulaiShift: string;
        };
    };
};

export type ParamsGetDetailShift = {
    shiftId: number | undefined;
};

export type GetDetailShiftResponse = {
    code: number;
    message: string;
    data: {
        id: number;
        kasir: {
            id: number;
            nama: string;
        };
        mulaiShift: string;
        akhirShift: string;
        pengeluaran: number;
        pendapatan: number;
        kasAwal: number;
        penerimaanSistem: number;
        kasAkhir: number;
        selisih: number;
        catatan: string;
    };
};

export type ParamsGetKantungParkir = {
    size: number;
    page: number;
};

export type ContentGetKantungParkir = {
    id: number;
    nama: string;
    tipeKendaraan: { id: number; nama: string; harga: number }[];
};

export type GetKantungParkirResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetKantungParkir[];
    };
};

export interface IDataLanggananMember {
    id: number;
    nama: string;
    nominal: string;
    totalHari: string;
    ukmId: number | undefined;
    tanggal?: Date | null;
    keterangan: string;
}

export interface IDataTambahInvoice {
    id: number;
    tanggalInvoice?: Date | null;
    noInvoice?: string;
    namaPerusahaan?: string;
    ruangan?: string;
    jenisSewa?: string;
    penyewaId: number;
    ruanganId: number;
    tanggalMulai: string | null;
    tanggalBerakhir: string | null;    
    tanggal?: string | null;
    jamMulai?: string | null;
    jamBerakhir?: string | null;
    tipeHarga: string;
    nominal: string;
    keterangan?: string;
    isReadOnly?: boolean;    
    tagihan?: number;
    jenisRuangan?: "Bulanan" | "Mingguan" | "Jam";
    periodeMingguan?: number;
    nominalHarga?: number;
}

export interface IDataPindahRuanganInvoice {
    id: number;
    tanggalPindah?: Date | null;
    ruanganTujuanId: number;
    noInvoice?: string;
    namaPerusahaan?: string;
    ruangan?: string;
    jenisSewa?: string;
    penyewaId: number;
    ruanganId?: number;
    tanggalMulai: string | null;
    tanggalBerakhir: string | null;    
    tanggal?: string | null;
    jamMulai?: string | null;
    jamBerakhir?: string | null;
    tipeHarga: string;
    nominal: string;
    keterangan?: string;
    isReadOnly?: boolean;    
    tagihan?: number;
    jenisRuangan?: "Bulanan" | "Mingguan" | "Jam";
    nominalHarga?: number;
}

export type ParamsGetRoomCoWork = {
    size: number;
    page: number;
    search: string;
    status: string;
};

export type ContentGetRoomList = {
    id: number;
    nama: string;
    kapasitas: number;
    hargaCustom: number;
    hargaSewaBulananMember: number;
    hargaSewaBulananNonMember: number;
    hargaSewaMember: number;
    hargaSewaNonMember: number;
    jenisSewa: string;
    status: "Disewa" | "Tersedia";
    isAktif: 0 | 1;
    isBooked: 0 | 1;
    ukm: { id: number; nama: string };
    penyewa: {
        nama: string;
        pic: string;
        teleponPic: string;
        periode: string;
        jamMulai: string;
        jamAkhir: string;
        tanggal: string;
    } | null;
    penyewaMendatang: {
        nama: string;
        pic: string;
        teleponPic: string;
        periode: string;
        jamMulai: string;
        jamAkhir: string;
        tanggal: string;
    } | null;
};

export type GetListRoomResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        totalAll: number;
        totalTerpakai: number;
        totalTidakTerpakai: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetRoomList[];
    };
};

export type ParamsGetRoomCoWorkExclusive = {
    size: number;
    page: number;
    search: string;
    status: string;
};

export type ContentGetRoomListExclusive = {
    ukm: { id: number; nama: string };
    hargaCustom: number;
    hargaSewaMember: number;
    hargaSewaNonMember: number;
    id: number;
    isKhusus: boolean;
    jenisSewa: string;
    kapasitas: number;
    nama: string;
    penyewa: {
        nama: string;
        pic: string;
        teleponPic: string;
        periode: string;
        jamMulai: string;
        jamAkhir: string;
        tanggal: string;
    } | null;
    status: string;
    isAktif: 0 | 1;
    isBooked: 0 | 1;
    penyewaMendatang: {
        nama: string;
        pic: string;
        teleponPic: string;
        periode: string;
        jamMulai: string;
        jamAkhir: string;
        tanggal: string;
    } | null;
};

export type GetListRoomExclusiveResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        totalAll: number;
        totalTerpakai: number;
        totalTidakTerpakai: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: ContentGetRoomListExclusive[];
    };
};

export interface AddRoomCoWork {
    id: number;
    ukmId: number | undefined;
    nama: string;
    kapasitas: number;
    jenisSewa: string;
    hargaSewaMember?: string;
    hargaSewaNonMember?: string;
    hargaSewaBulananMember?: string;
    hargaSewaBulananNonMember?: string;
}

export type EditRoomBody = {
    id: number;
    ukmId?: number | undefined;
    ukm?: { id: number; nama: string };
    nama: string;
    kapasitas: number;
    jenisSewa: string;
    hargaSewaMember?: string;
    hargaSewaNonMember?: string;
    hargaSewaBulananMember?: string;
    hargaSewaBulananNonMember?: string;
};

export interface AddRoomCoWorkKhusus {
    id: number;
    ukmId: number | undefined;
    nama: string;
    kapasitas: number;
    jenisSewa: string;
    hargaSewaMember?: string;
    hargaSewaNonMember?: string;
    hargaSewaBulananMember?: string;
    hargaSewaBulananNonMember?: string;
}

export type EditRoomKhususBody = {
    id: number;
    ukmId?: number | undefined;
    ukm?: { id: number; nama: string };
    nama: string;
    kapasitas: number;
    jenisSewa: string;
    hargaSewaMember?: string;
    hargaSewaNonMember?: string;
    hargaSewaBulananMember?: string;
    hargaSewaBulananNonMember?: string;
};

export type ParamsGetListPenyewa = {
    size: number;
    page: number;
    search: string;
    status: string;
    tanggalAwal: string;
    tanggalAkhir: string;
};

export type ParamsGetListInvoicePenyewa = {
    size: number;
    page: number;
    search: string;
    status: string;
    tanggalAwal: string;
    tanggalAkhir: string;
};

export type DataListInvoicePenyewa = {
    id: number;
    noInvoice: string;
    penyewaId: number;
    namaPerusahaan: string;
    ruanganId: number;
    ruangan: string;
    tagihan: number;
    tagihanBulanan: number;
    tipeHarga: string;
    tanggalMulai: string | null;
    tanggalBerakhir: string | null;
    jatuhTempo: string;
    status: string;
    keterangan: string;
    kategori: 0 | 1;
};

export type GetListInvoicePenyewaResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        content: DataListInvoicePenyewa[];
        summary: {
            totalRuangDisewa: number;
            dibayar: number;
            booked: number;
            belumDibayar: number;
            nominalKeseluruhan: number;
            nominalBelumDibayar: number;
            nominalDibayar: number;
            nominalBooked: number;
        }
    };
};

export interface AddPenyewaCoWork {
    id: number;
    ukmId: number | undefined;
    namaPerusahaan: string;
    npwpPerusahaan: string;
    nomorTelepon: string;
    alamat: string;
    namaPic: string;
    nomorTeleponPic: string;
    alamatPic: string;
    npwpPic: string;
    noKtpPic: string;
}

export type EditPenyewaBody = {
    id: number;
    ukmId: number | undefined;
    namaPerusahaan: string;
    nomorTelepon: string;
    alamat: string;
    namaPic: string;
    nomorTeleponPic: string;
    alamatPic: string;
};

export type DataPenyewa = {
    id: number;
    ukm: { id: number; nama: string };
    namaPerusahaan: string;
    npwpPerusahaan: string;
    nomorTelepon: string;
    alamat: string;
    namaPic: string;
    nomorTeleponPic: string;
    alamatPic: string;
    npwpPic: string;
    noKtpPic: string;
    status: string;
    tanggalDibuat: string;
};

export type GetListPenyewaResponse = {
    code: number;
    message: string;
    data: {
        totalElements: number;
        totalAll: number;
        page: number;
        lastPage: boolean;
        size: number;
        nextId: number;
        summary: {
            penyewaAktif: number;
            penyewaTidakAktif: number;
        },
        content: DataPenyewa[];
    };
};
